import React, { useLayoutEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { Button, Icon, fmtCoins } from "../ui";
import { useToast } from "../../context/ToastContext";
import PopMenu from "./PopMenu";
import { UNAVAILABLE } from "./format";

export const MAX_LEN = 6000;

/** กล่องพิมพ์: แทรก * * / " ", โมเดล+ราคา, เมนู +, ปุ่มส่งแสดงราคา ; ฟีเจอร์ที่ยังไม่มีแสดงป้าย "ยังไม่เปิดให้บริการ" */
export default function Composer({ text, setText, onSend, sending, model, cost, coins, onModel, onGift, notice, onNotice, disabled }) {
  const toast = useToast();
  const ta = useRef(null);
  const known = typeof coins === "number";
  const low = known && cost > 0 && coins < cost;

  // ขยายช่องพิมพ์ตามข้อความ (สูงสุด 140px)
  useLayoutEffect(() => {
    const el = ta.current;
    if (!el) return;
    el.style.height = "auto";
    el.style.height = `${Math.min(140, el.scrollHeight)}px`;
  }, [text]);

  // แทรกเครื่องหมายตรงเคอร์เซอร์ (ถ้าเลือกข้อความไว้จะครอบให้)
  const wrap = (open, close) => {
    const el = ta.current;
    if (!el) return;
    const a = el.selectionStart ?? text.length;
    const b = el.selectionEnd ?? text.length;
    const next = text.slice(0, a) + open + text.slice(a, b) + close + text.slice(b);
    setText(next);
    requestAnimationFrame(() => { el.focus(); el.setSelectionRange(a + open.length, b + open.length); });
  };
  const soon = (what) => toast(`${what}: ${UNAVAILABLE}`, "info");
  const onKey = (e) => {
    if (e.key === "Enter" && !e.shiftKey && !e.nativeEvent.isComposing) { e.preventDefault(); onSend(); }
  };

  return (
    <div className="composer">
      {notice ? (
        <div className={`notice ${notice.noCharge ? "notice--info" : "notice--error"}`} role="alert">
          <span className="grow">{notice.needCoins ? `คอยน์ไม่พอ ต้องการ ${fmtCoins(notice.need ?? cost)}${notice.have !== undefined ? ` แต่มี ${fmtCoins(notice.have)}` : ""} คอยน์` : notice.message}</span>
          {notice.needCoins ? <><Link to="/coins" className="btn btn--sm btn--primary">เติมคอยน์</Link><Button size="sm" onClick={onModel}>เปลี่ยนโมเดล</Button></> : null}
          {notice.retryable && notice.retryText ? <Button size="sm" variant="primary" onClick={() => onSend(notice.retryText)}>ลองส่งใหม่</Button> : null}
          <Button size="sm" icon variant="ghost" aria-label="ปิดข้อความ" onClick={() => onNotice(null)}><Icon name="x" size={14} /></Button>
        </div>
      ) : low ? (
        <div className="notice notice--error" role="alert">
          <span className="grow">คอยน์ไม่พอสำหรับโมเดลนี้ ({fmtCoins(cost)} คอยน์/ข้อความ · เหลือ {fmtCoins(coins)})</span>
          <Link to="/coins" className="btn btn--sm btn--primary">เติมคอยน์</Link>
          <Button size="sm" onClick={onModel}>เปลี่ยนโมเดล</Button>
        </div>
      ) : null}
      <div className="composer__row">
        <PopMenu up label="เมนูเพิ่มเติม" className="composer__plus" trigger={<Button icon aria-label="เมนูเพิ่มเติม"><Icon name="plus" /></Button>} items={[
          { label: "ส่งของขวัญ", icon: "gift", onClick: onGift },
          { label: "อัปโหลดรูปภาพ", icon: "image", badge: UNAVAILABLE, onClick: () => soon("อัปโหลดรูปภาพ") },
          { label: "โทรด้วยเสียง", icon: "phone", badge: UNAVAILABLE, onClick: () => soon("โทรด้วยเสียง") },
          { label: "สร้างรูปภาพ", icon: "image", badge: UNAVAILABLE, onClick: () => soon("สร้างรูปภาพ") },
          { label: "ดูดวงไพ่ทาโรต์", icon: "cards", badge: UNAVAILABLE, onClick: () => soon("ดูดวงไพ่ทาโรต์") },
        ]} />
        <textarea ref={ta} rows={1} placeholder="เขียนข้อความ" aria-label="เขียนข้อความ" maxLength={MAX_LEN} value={text} disabled={disabled}
          onChange={(e) => setText(e.target.value)} onKeyDown={onKey} />
        <Button variant="primary" className="composer__send" aria-label={`ส่งข้อความ ใช้ ${cost} คอยน์`} onClick={() => onSend()} disabled={sending || disabled || !text.trim() || low}>
          <Icon name="send" size={18} /><span className="composer__cost">{cost}</span>
        </Button>
      </div>
      <div className="composer__tools">
        <Button size="sm" variant="ghost" onClick={() => wrap("*", "*")} aria-label="แทรกการกระทำ">* *</Button>
        <Button size="sm" variant="ghost" onClick={() => wrap('"', '"')} aria-label="แทรกบทพูด">" "</Button>
        <span className="faint" style={{ fontSize: 11 }}>Enter ส่ง · Shift+Enter ขึ้นบรรทัดใหม่</span>
        <div className="grow" />
        {text.length > MAX_LEN * 0.8 ? <span className={text.length >= MAX_LEN ? "error-text" : "faint"} style={{ fontSize: 11 }}>{text.length.toLocaleString("th-TH")}/{MAX_LEN.toLocaleString("th-TH")}</span> : null}
        <button className="model-chip" onClick={onModel} aria-label={`โมเดล AI: ${model?.name || ""} ${cost} คอยน์ต่อข้อความ`}>
          <Icon name="sparkle" size={14} />{model?.name || "โมเดล"}<span className="coin"><i className="coin__dot" />{cost}</span>
        </button>
      </div>
      <div className="faint center" style={{ fontSize: 11 }}>ทุกสิ่งที่ตัวละครพูดเป็นการแต่งเรื่อง</div>
    </div>
  );
}
